import { render, staticRenderFns } from "./files-operations.vue?vue&type=template&id=8ae1ef22&scoped=true"
import script from "./files-operations.vue?vue&type=script&lang=js"
export * from "./files-operations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae1ef22",
  null
  
)

export default component.exports